import templateStr from 'text!./mobileCoverages.html';

export default {
    template: templateStr,
    bindings: {
        coverages: '<',
        branchCode: '=',
        schedules: '<'
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/ho/directives/HoOfferingSelection/mobileQuoteView/mobileCoverages/mobileCoverages.js
// module id = 2161
// module chunks = 0